import { get, post, put, del } from "@/api/common/request";

// 注意：
// 1）以下接口路径是基于当前项目风格的“推测/约定”，请按后端实际路由必要时调整；
// 2）前端只做页面与参数组装，后端校验/权限控制以服务端为准。

// ===== 异常行为监控项配置 =====
// 列表：GET /risk-items，入参：page_num、page_size
export const listRiskItems = (params = {}) => get("/risk-items", params);

// 兼容旧路径（若后端仍保留）
// /anticheat/behavior-config/list
export const listBehaviorConfigs = (params = {}) => get("/anticheat/behavior-config/list", params);

// 添加：POST /risk-items
// 入参：
// - behavior_desc: string
// - risk_score: number (0-100, integer)
// - remarks: string
// - weight: string (1-高 / 2-中 / 3-低)
// - risk_category: string (1-视觉监控 / 2-声音监控 / 3-屏幕与操作监控)
// - sort_order: number (integer, >= 0)
export const addBehaviorConfig = (params = {}) => post("/risk-items", params);

// /anticheat/behavior-config/edit
// 入参：id（或 userid）、risk_score、weight、remarks（可选）
export const editBehaviorConfig = (params = {}) => put("/anticheat/behavior-config/edit", params);

// ===== 异常行为监控项配置（新接口约定）=====
// 根据需求：PUT /risk-items/{action_type}
// action_type：由列表数据的 action_type 透传
// 入参：behavior_desc / risk_category / risk_score / sort_order / remarks / weight
// 说明：字段类型与命名请以后端最终契约为准。
export const editRiskItem = (action_type, params = {}) =>
  put(`/risk-items/${action_type}`, params);

// 根据需求：DELETE /risk-items/{action_type}
// action_type：由列表数据的 action_type 透传
// 说明：删除接口入参未完全给出，这里按 edit 入参子集透传（由后端决定是否需要 sort_order/id 等字段）。
export const deleteRiskItem = (action_type, params = {}) =>
  del(`/risk-items/${action_type}`, params);

// ===== 风险等级阈值配置 =====
// 列表：GET /risk-levels
// 入参：可扩展 query 参数（按后端实际需要传）
export const listRiskLevels = (params = {}) => get("/risk-levels", params);

// 添加：POST /risk-levels
// 入参：
// - level_name: string
// - level_code: number
// - min_score: number
// - max_score: number
// - description: string
export const addRiskLevel = (params = {}) => post("/risk-levels", params);

// 更新：PUT /risk-levels/{risk_level_id}
// 入参（前端传对象即可）：
// - risk_level_id / id：路径参数
// - 其余字段：level_name、level_code、min_score、max_score、description
export const editRiskLevel = (params = {}) => {
  const risk_level_id = params.risk_level_id ?? params.id ?? null;
  const { risk_level_id: _rid, id: _id, ...body } = params || {};
  return put(`/risk-levels/${encodeURIComponent(String(risk_level_id))}`, body);
};

// 删除：DELETE /risk-levels/{risk_level_id}
// 入参：risk_level_id / id
export const removeRiskLevel = (params = {}) => {
  const risk_level_id = params.risk_level_id ?? params.id ?? null;
  return del(`/risk-levels/${encodeURIComponent(String(risk_level_id))}`);
};

